import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore, useTenantInMarketStore } from "..";
import useTenantsInMarketWithGlobalFilters from "../interfaces/useTenantsInMarketWithGlobalFilters";
import useTenantsInMarketWithFocusArea from "./useTenantsInMarketWithFocusArea";

export default function () {
    const tenantInMarketStore = useTenantInMarketStore();
    const pipedriveStore = usePipedriveStore();
    const tenantsInMarket = useTenantsInMarketWithFocusArea(useTenantsInMarketWithGlobalFilters(tenantInMarketStore.tenantsInMarket));

    return useMemo(() => computed(() => {
        const availableOwners = _.sortBy(pipedriveStore.users.filter(u => tenantsInMarket.some(tim => tim.assignedToPipedriveUserId === u.id)).map(u => u.name));

        return ["All Owners", "None"].concat(availableOwners);
    }), [tenantsInMarket]).get();
}